import { render, staticRenderFns } from "./workspace-invite-member.vue?vue&type=template&id=f37eb454&"
import script from "./workspace-invite-member.vue?vue&type=script&lang=js&"
export * from "./workspace-invite-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports